import React from 'react';
import { css } from 'emotion';
import { ElementRoot } from '@whalecloud/page-builder-core/components/ElementRoot';
import { Checkbox } from '@whalecloud/fdx';
import FormItem from "@whalecloud/page-builder-core/components/Render/components/FormItem";
import { makeEventProps } from '@whalecloud/page-builder-core/utils/common';

const left = css({ textAlign: 'left' });
const RadioGroup = props => {
  const { element, nameSpace } = props;
  const { formItemSettings, formSettings, settings, className = '' } = element.data;
  const { horizontalAlign = 'left' } = settings;
  const eventProps = makeEventProps(element.data.events, nameSpace);

  return (
    <ElementRoot className={'webiny-pb-base-page-element-style'} element={element}>
      {({ getAllClasses, elementStyle }) => (
        <div style={{ textAlign: horizontalAlign }}>
          <FormItem
            id={element.id}
            style={elementStyle}
            className={getAllClasses('webiny-pb-base-page-element-style', 'webiny-pb-page-element-radio-group', left)}
            {...formSettings}
          >
            <Checkbox.Group {...formItemSettings} className={className} />
          </FormItem>
        </div>
      )}
    </ElementRoot>
  );
};

export default RadioGroup;
